// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Karla:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: "Karla", sans-serif;
  background: linear-gradient(to bottom, #ffffff -8%, #e0ece0 59%, #ddebdd 0%);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-container {
  position: relative;
  background-color: white;
  padding: 5rem 2rem;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
}

.login-form {
  display: flex;
  flex-direction: column;
}

h2 {
  text-align: center;
  font-family: "Karla", sans-serif;
}

.login-heading {
  font-size: 50px;
  padding: 10px 20px;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  color: #333;
}

.form-group {
  margin-bottom: 1rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: #555;
}

input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: "Karla", sans-serif;
}

.login-button {
  padding: 20px 10px 20px 35px;
  width: 40%;
  margin-right: 30%;
  height: 55px;
  font-weight: 400;
  font-size: 27px;
}

.forget-password {
  margin-left: 20px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 50%;
  top: 75%;
  text-align: center;
  margin-top: 10px;
}

.forget-password-button {
  border: none;
  color: blue;
  cursor: pointer;
}

.bordered-box {
  border: 2px solid #4caf50;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.otp-input,
.new-password-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.phone-input {
  padding: 8px 1px 8px 1px;
  width: 100%;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.send-otp-button,
.cancel-button,
.validate-otp-button,
.login-after-otp-button,
.reset-password-button,
.reset-password-submit-button {
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}

.send-otp-button:disabled {
  margin-right: 10px;
  background-color: #717070;
  cursor: not-allowed;
}

/* reseat password css */
.reset-password-container {
  border: 1px solid #ccc;

  top: 50px;

  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: linear-gradient(to bottom, #ffffff -8%, #e0ece0 59%, #ddebdd 0%);
  font-family: "Karla", sans-serif;
}
.submit-button-container {
  display: flex;
  justify-content: center;
}
.reset-password-submit-button {
  padding: 8px 14px !important;
  justify-content: center;
}

.first-login-heading {
  font-size: 34px;
  color: rgb(13, 124, 102);
}

.sign-in-header {
  color: rgb(13, 124, 102);
  text-align: center;
}

/* ===== Password field with eye icon ===== */

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  width: 100%;
  padding-right: 40px; /* space for icon */
}

.eye-icon {
  position: absolute;
  right: 12px;
  cursor: pointer;
  color: #555;
  font-size: 18px;
}

.eye-icon:hover {
  color: #4caf50;
}
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.popup-content {
  background: white;
  padding: 20px;
  width: 90%;
  max-width: 400px;
  border-radius: 10px;
  text-align: center;
}

/* ===========================
   MOBILE & TABLET RESPONSIVE
   =========================== */

@media (max-width: 768px) {
  body {
    padding: 16px;
    height: auto;
    align-items: flex-start;
  }

  .login-container {
    padding: 2rem 1.5rem;
    max-width: 100%;
    margin-top: 40px;
  }

  .login-heading {
    font-size: 28px;
    padding: 10px;
    margin-bottom: 1rem;
  }

  .login-form {
    width: 100%;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  label {
    font-size: 14px;
  }

  input,
  .new-password-input,
  .phone-input {
    font-size: 14px;
    padding: 10px;
  }

  .reset-password-submit-button {
    width: 100%;
    padding: 12px;
    font-size: 16px;
    /* margin-top: 10px; */
    justify-content: center !important;
  }

  .error-message {
    font-size: 14px;
    text-align: center;
  }

  .forget-password {
    position: static;
    transform: none;
    margin-top: 15px;
    text-align: center;
  }
}

/* ===========================
   SMALL MOBILE (≤ 480px)
   =========================== */

@media (max-width: 480px) {
  .login-heading {
    font-size: 24px;
  }

  .login-container {
    padding: 1.5rem 1rem;
    border-radius: 6px;
  }

  input {
    font-size: 13px;
  }

  .reset-password-submit-button {
    font-size: 15px;
    /* padding: 10px; */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Login/Login.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,4EAA4E;EAC5E,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;AACA;;;;;;EAME,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;;EAEtB,SAAS;;EAET,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4EAA4E;EAC5E,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,6CAA6C;;AAE7C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB,EAAE,mBAAmB;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;gCAEgC;;AAEhC;EACE;IACE,aAAa;IACb,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;;gCAEgC;;AAEhC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Karla:wght@400;700&display=swap\");\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: \"Karla\", sans-serif;\n  background: linear-gradient(to bottom, #ffffff -8%, #e0ece0 59%, #ddebdd 0%);\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-container {\n  position: relative;\n  background-color: white;\n  padding: 5rem 2rem;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 400px;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n}\n\nh2 {\n  text-align: center;\n  font-family: \"Karla\", sans-serif;\n}\n\n.login-heading {\n  font-size: 50px;\n  padding: 10px 20px;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  color: #333;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #555;\n}\n\ninput {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-family: \"Karla\", sans-serif;\n}\n\n.login-button {\n  padding: 20px 10px 20px 35px;\n  width: 40%;\n  margin-right: 30%;\n  height: 55px;\n  font-weight: 400;\n  font-size: 27px;\n}\n\n.forget-password {\n  margin-left: 20px;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 50%;\n  top: 75%;\n  text-align: center;\n  margin-top: 10px;\n}\n\n.forget-password-button {\n  border: none;\n  color: blue;\n  cursor: pointer;\n}\n\n.bordered-box {\n  border: 2px solid #4caf50;\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.otp-input,\n.new-password-input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.phone-input {\n  padding: 8px 1px 8px 1px;\n  width: 100%;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.send-otp-button,\n.cancel-button,\n.validate-otp-button,\n.login-after-otp-button,\n.reset-password-button,\n.reset-password-submit-button {\n  padding: 10px 20px;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-right: 10px;\n}\n\n.send-otp-button:disabled {\n  margin-right: 10px;\n  background-color: #717070;\n  cursor: not-allowed;\n}\n\n/* reseat password css */\n.reset-password-container {\n  border: 1px solid #ccc;\n\n  top: 50px;\n\n  margin: 0 auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  background: linear-gradient(to bottom, #ffffff -8%, #e0ece0 59%, #ddebdd 0%);\n  font-family: \"Karla\", sans-serif;\n}\n.submit-button-container {\n  display: flex;\n  justify-content: center;\n}\n.reset-password-submit-button {\n  padding: 8px 14px !important;\n  justify-content: center;\n}\n\n.first-login-heading {\n  font-size: 34px;\n  color: rgb(13, 124, 102);\n}\n\n.sign-in-header {\n  color: rgb(13, 124, 102);\n  text-align: center;\n}\n\n/* ===== Password field with eye icon ===== */\n\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper input {\n  width: 100%;\n  padding-right: 40px; /* space for icon */\n}\n\n.eye-icon {\n  position: absolute;\n  right: 12px;\n  cursor: pointer;\n  color: #555;\n  font-size: 18px;\n}\n\n.eye-icon:hover {\n  color: #4caf50;\n}\n.popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.popup-content {\n  background: white;\n  padding: 20px;\n  width: 90%;\n  max-width: 400px;\n  border-radius: 10px;\n  text-align: center;\n}\n\n/* ===========================\n   MOBILE & TABLET RESPONSIVE\n   =========================== */\n\n@media (max-width: 768px) {\n  body {\n    padding: 16px;\n    height: auto;\n    align-items: flex-start;\n  }\n\n  .login-container {\n    padding: 2rem 1.5rem;\n    max-width: 100%;\n    margin-top: 40px;\n  }\n\n  .login-heading {\n    font-size: 28px;\n    padding: 10px;\n    margin-bottom: 1rem;\n  }\n\n  .login-form {\n    width: 100%;\n  }\n\n  .form-group {\n    margin-bottom: 1rem;\n  }\n\n  label {\n    font-size: 14px;\n  }\n\n  input,\n  .new-password-input,\n  .phone-input {\n    font-size: 14px;\n    padding: 10px;\n  }\n\n  .reset-password-submit-button {\n    width: 100%;\n    padding: 12px;\n    font-size: 16px;\n    /* margin-top: 10px; */\n    justify-content: center !important;\n  }\n\n  .error-message {\n    font-size: 14px;\n    text-align: center;\n  }\n\n  .forget-password {\n    position: static;\n    transform: none;\n    margin-top: 15px;\n    text-align: center;\n  }\n}\n\n/* ===========================\n   SMALL MOBILE (≤ 480px)\n   =========================== */\n\n@media (max-width: 480px) {\n  .login-heading {\n    font-size: 24px;\n  }\n\n  .login-container {\n    padding: 1.5rem 1rem;\n    border-radius: 6px;\n  }\n\n  input {\n    font-size: 13px;\n  }\n\n  .reset-password-submit-button {\n    font-size: 15px;\n    /* padding: 10px; */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
